/**
 * Registrazione del service worker Visite (/visite-sw.js, scope /visite).
 * Registrato solo nel build di produzione, oppure con REACT_APP_VISITE_SW=1.
 */
export const VISITE_SW_URL = "/visite-sw.js";
export const VISITE_SW_SCOPE = "/visite";
export const VISITE_UPDATE_EVENT = "visite-sw-update";

let waitingWorker = null;
let reloading = false;
let updateRequested = false;

export function visiteSwEnabled(env = process.env) {
  return env.NODE_ENV === "production" || env.REACT_APP_VISITE_SW === "1";
}

function announce(worker) {
  waitingWorker = worker;
  window.dispatchEvent(new CustomEvent(VISITE_UPDATE_EVENT, { detail: { waiting: true } }));
}

export async function registerVisiteServiceWorker({ nav = typeof navigator !== "undefined" ? navigator : null, env = process.env } = {}) {
  if (!nav || !("serviceWorker" in nav) || !visiteSwEnabled(env)) return null;
  try {
    const reg = await nav.serviceWorker.register(VISITE_SW_URL, { scope: VISITE_SW_SCOPE });
    if (reg.waiting && nav.serviceWorker.controller) announce(reg.waiting);
    reg.addEventListener("updatefound", () => {
      const w = reg.installing;
      if (!w) return;
      w.addEventListener("statechange", () => {
        if (w.state === "installed" && nav.serviceWorker.controller) announce(w);
      });
    });
    nav.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading || !updateRequested) return;
      reloading = true;
      window.location.reload();
    });
    const check = () => reg.update().catch(() => {});
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") check();
    });
    return reg;
  } catch {
    return null;
  }
}

export function hasVisiteUpdate() {
  return !!waitingWorker;
}

export function applyVisiteUpdate() {
  if (!waitingWorker) return false;
  updateRequested = true;
  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  return true;
}

export function __resetVisiteSw() {
  waitingWorker = null;
  reloading = false;
  updateRequested = false;
}
